import React from "react";
import style from "./dialog.module.css";

const Dialog = ({
    isOpen,
    title,
    description,
    actions = [],
    onClose
}) => {
    if (!isOpen) return null;

    return (
        <div
            className={[style.dialogView]}
            onClick={onClose}
        >
            <div
                className={[style.dialogContents]}
                onClick={(e) => e.stopPropagation()}
            >
                <div>
                    {title && (
                        <div className={[style.title]}>{title}</div>
                    )}

                    {description && (
                        <p className={[style.description]}>{description}</p>
                    )}
                </div>

                {/* Action Buttons */}
                <div className={[style.mgT20px]}>
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            className={[style.actionBtn, action.variant == 'positive' ? style.positiveBtn : action.variant == 'negative' ? style.negativeBtn : style.neutralBtn].join(" ")}
                            onClick={action.onClick}
                        >
                            {action.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Dialog;